module.exports = __webpack_public_path__ + "img/crusher1.91986ea9.png";